(function() { window.GUID_2eb29740_8367_4713_9881_cfe9b7de7874 = { getGuid: function() { return "2eb29740-8367-4713-9881-cfe9b7de7874"; } }; })();
window.fbAsyncInit = function () {
    if (typeof (FB) !== 'undefined') {
        FB.init({
            appId: CS.GlobalConst.FacebookAppKey,
            autoLogAppEvents: true,
            xfbml: true,
            version: 'v19.0',
        });
        $('html body').trigger('facebookinitialized');
        console.debug('facebook initialized');
    }
};
(function (d, s, id) {
    var js, fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) {
        return;
    }
    js = d.createElement(s);
    js.id = id;
    js.src = "https://connect.facebook.net/en_US/sdk.js";
    fjs.parentNode.insertBefore(js, fjs);
}(document, 'script', 'facebook-jssdk'));
var Facebook;
(function (Facebook) {
    function Share(urlToShare) {
        let data = {
            url: urlToShare,
        };
        CS.Ajax.Post("/Facebook/FetchFacebookUrl", data, function (response) {
            setTimeout(function () {
                if (typeof (FB) !== 'undefined') {
                    FB.ui({
                        method: 'share',
                        href: data.url,
                    }, function (response) { });
                }
                ;
            }, 500);
        });
    }
    Facebook.Share = Share;
    // export function Share() {
    //    FB.api('https://graph.facebook.com/', 'post', {
    //        id: 'https://compusport.ca/Sharefacebook1.html',
    //        access_token: '1094699144002890|O7WxCbOMP_JiCKQBq1VNixF40fI',
    //        scrape: true
    //    }, function (response) {
    //        setTimeout(function () {
    //            FB.ui({
    //                method: 'share',
    //                href: 'https://compusport.ca/Sharefacebook1.html'
    //            }, function (response) { });
    //        }, 1000);
    //    });
    // }
})(Facebook || (Facebook = {}));

//# sourceMappingURL=facebook.js.map
